import type { ReactNode } from 'react';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
  label: {
    color: token('color.text.subtle'),
    font: token('font.body.small'),
    fontWeight: token('font.weight.medium'),
  },
});

/** Site and Bitbucket field labels: Body/S/Medium + color.text.subtle. */
const FieldLabel = ({ children }: { children: ReactNode }) => (
  <span css={styles.label}>{children}</span>
);

export default FieldLabel;
